/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_Status_Coach_PreparedInputs */

const fr_session_status_coach_prepared = /** @type {(inputs: Session_Status_Coach_PreparedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En préparation`)
};

/**

* @param {Session_Status_Coach_PreparedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const session_status_coach_prepared = /** @type {((inputs?: Session_Status_Coach_PreparedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Status_Coach_PreparedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_session_status_coach_prepared(inputs)
});